import React from 'react'
import { NavLink, useNavigate } from 'react-router-dom'
import image from "../images"
import Profile from './Profile'
import userData from '../userData'
import "../css/navbar.css"





function Navbar(props) {

    const navigate = useNavigate();
    const token = localStorage.getItem("token")
    // console.log(object)

    return (
        <div className="navbar">
            <NavLink className="home" to="/home"><div ><h1 className="logo"><img class="petHouse" src={image.petHouse} alt="animals-profile" />Pet<span className="logo-me" >Me</span></h1></div></NavLink>
            <input className="checkbox" type="checkbox" />
            <ul className="menu">

                <li ><a className="item navbar-food" href="https://www.amazon.in/hz/wishlist/ls/68D6XJ7HA7PJ?ref_=wl_share" aria-label="Amazon-pet-food" rel="noopener" target="_blank">Pet Food</a></li>
                <li ><a className="item navbar-accessories" href="https://www.amazon.in/hz/wishlist/ls/E90HH62SU2AU?ref_=wl_share" aria-label="Amazon-pet-accessories" rel="noopener" target="_blank">Pet Accessories</a></li>
                <li ><NavLink className="item navbar-options" to="/aboutus">About Us</NavLink></li>
                <li ><NavLink className="item navbar-options" to="/contact">Contact</NavLink></li>
                {token && <li> <NavLink className="item navbar-login" to="/home" onClick={() => {
                    localStorage.removeItem('token')
                }}> Logout</NavLink></li>}


                {!token && <li ><NavLink className="item navbar-login" to="/login">Log In</NavLink></li>}

                {!token && <li ><NavLink className="item navbar-signUp navbar-options" to="/signup">Sign Up</NavLink></li>}
                {token && <li>
                    <Profile
                        userImg={userData[0].userImg}
                        userName={userData[0].userName}
                        userEmail={userData[0].userEmail}
                    />
                </li>}
            </ul>
            <div className="burger">
                <div className="burger-line line1"></div>
                <div className="burger-line line2"></div>
                <div className="burger-line line3"></div>
            </div>
        </div>
    )
}



export default Navbar


